// @flow
import * as React from 'react';
import type { Question } from 'models';
import { ContentSection } from './ContentSection';
import {
  PwrUgcMetaInfo,
  ClientUgcMetaInfo,
} from 'components/ContentSection/UgcMetaInfo';
import { Article } from './QAComponents';
import { AnswerArticle } from './AnswerArticle';

type Props = {
  ugc: Question,
  children?: ?React.Node,
  MetaInfoComponent: React.ComponentType<{ model: Ugc }>,
  subject: Product,
  locale: string,
  allowMedia: boolean,
};
export class QuestionSection extends React.Component<Props> {
  static defaultProps = {
    MetaInfoComponent: ClientUgcMetaInfo,
  };

  getAnswers(question: Question) {
    const answers = question.ugc_related_content.filter(
      ugc => ugc && ugc.ugc_archetype === 'Answer'
    );

    return answers;
  }

  render() {
    const {
      ugc,
      children: addAnswerTextBox,
      MetaInfoComponent,
      subject,
      locale,
      allowMedia,
    } = this.props;
    const answers = this.getAnswers(ugc);

    const body = (() => {
      if (answers.size === 0 && !addAnswerTextBox) return null;

      const answerElements = answers.map((answer, index, list) => {
        return (
          <React.Fragment key={answer.ugc_id}>
            <div className="mh4 mv3">
              <AnswerArticle
                ugc={answer}
                viewContext="Question"
                parentUgcId={ugc.ugc_id}
                subject={subject}
                locale={locale}
                allowMedia={allowMedia}
              />
            </div>
            <hr className="ml0 mr0 bb bt-0 b--black-05" />
          </React.Fragment>
        );
      });

      return (
        <React.Fragment>
          {answerElements}
          <div className="ma4">{addAnswerTextBox}</div>
        </React.Fragment>
      );
    })();

    return (
      <ContentSection>
        <ContentSection.Section>
          <Article ugc={ugc} />
        </ContentSection.Section>
        <ContentSection.Divider />
        {body}
        <ContentSection.Meta>
          <MetaInfoComponent model={ugc} />
        </ContentSection.Meta>
      </ContentSection>
    );
  }
}

export const PwrQuestionSection = (props: Props) => (
  <QuestionSection {...props} MetaInfoComponent={PwrUgcMetaInfo} />
);



// WEBPACK FOOTER //
// ./src/components/ContentSection/__future__/QuestionSection.js